import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { PREFECTURES } from "../../constants/prefectures";
import { storeActions } from "./actions";
import { Store, StoreState } from "./types";

const initialState: StoreState = {
  allStores: [],
  favoriteStores: null,
  prefectures: PREFECTURES.reduce(
    (acc, cur) => {
      acc[cur.name] = [];
      return acc;
    },
    {} as Record<string, string[]>,
  ),
};

export function StoreReducer(state = initialState, action: Action): StoreState {
  if (isType(action, storeActions.getStores.done)) {
    if (action.payload.params.conditions.length > 0) return state;

    const prefectures: Record<string, string[]> = {};
    const favoriteStores: Store[] = [];

    action.payload.result.forEach((store) => {
      if (!prefectures[store.prefecture]) {
        prefectures[store.prefecture] = [];
      }

      if (!prefectures[store.prefecture].includes(store.city)) {
        prefectures[store.prefecture].push(store.city);
      }

      if (store.isFavorite) {
        favoriteStores.push(store);
      }
    });

    return {
      ...state,
      allStores: action.payload.result,
      favoriteStores,
      prefectures,
    };
  }

  if (isType(action, storeActions.setFavoriteStore.done)) {
    const newStores = state.allStores.map((store) => {
      if (store.id === action.payload.params.store_id) {
        return { ...store, isFavorite: action.payload.params.enable };
      }
      return store;
    });

    return {
      ...state,
      allStores: newStores,
      favoriteStores: newStores.filter((store) => store.isFavorite),
    };
  }

  if (isType(action, storeActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
